import { ENTITY_TYPES } from "./projects";

export const EMPTY_CHAT_RESPONSE = {
  entity: ENTITY_TYPES.screen,
  field: "",
  llm_message: "",
  slug: "",
  value: "",
};
